module.exports = new __parcel__URL__("match-browser.defc82cb.svg").toString();